import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from '@/shared/ui/use-toast';
import { useMe } from '@/features/profile/use-me';
import { updateMe } from '@/features/profile/api';

export function useCurrency() {
  const { data: me } = useMe();
  const qc = useQueryClient();

  const code = me?.preferences?.default_currency ?? 'USD';

  const mutation = useMutation({
    mutationFn: (newCode: string) =>
      updateMe({ preferences: { default_currency: newCode } }),
    // No optimistic update here on purpose: the displayed code, the FX-converted
    // table prices and the "Цена (вид.)" column header all read from server data
    // that depends on this same preference. Flipping the badge instantly while the
    // table catches up 200-500ms later is what caused the "jump" — everything
    // must land in one atomic transition instead. The trigger's spinner (isPending)
    // is the only immediate feedback; nothing else changes until every dependent
    // query has actually refetched.
    onSuccess: async () => {
      await Promise.all([
        qc.invalidateQueries({ queryKey: ['me'] }),
        qc.invalidateQueries({ queryKey: ['listings'] }),
        qc.invalidateQueries({ queryKey: ['listing'] }),
      ]);
    },
    onError: () => {
      toast({ title: 'Ошибка', description: 'Не удалось сохранить валюту', variant: 'destructive' });
    },
  });

  return {
    code,
    setCurrency: (newCode: string) => mutation.mutate(newCode),
    isPending: mutation.isPending,
  };
}
